/**
 * Created by dvircohen on 21/09/2016.
 */
(function () {
    'use strict';

    // @ngInject
    function AgreementTemplateEmptyStateControllerCtor($scope, $injector, AnalyticsService, TemplatesViewService, $state, AppStates) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'AgreementTemplateEmptyStateController';
        AnalyticsService.trackPageView(this, 'AgreementTemplateEmptyStateView');

        this.TemplatesViewService = TemplatesViewService;
        this.$state = $state;
        this.AppStates = AppStates;
    }

    Controllers.AgreementTemplateEmptyStateController = Class(Controllers.BaseController, {
        constructor: AgreementTemplateEmptyStateControllerCtor
    });
}());

